import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  TextField,
  Tab,
  Tabs,
  Box,
} from "@mui/material";
import React, { forwardRef, useCallback, useImperativeHandle } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import { styled, useTheme } from "@mui/material/styles";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "src/app/main/utilities/AgGridTable";
import FormPageHeader from "../../utilities/FormPageHeader";
import moment from "moment";
import "../expense-claim/expenseClaim.css";

const expenseListURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      padding: "5px 10px",
      cursor: "pointer",

      "&:hover": {
        backgroundColor: "grey",
      },
    },
    fontSize: "11px",
    textAlign: "center",
    height: "26px",
    lineHeight: "26px",
    padding: "0px 10px",
    marginTop: "6px",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            width: "68vw !important",

            padding: 1,
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}
const payGroupOptions = [
  { label: "ALL", value: "ALL" },
  { label: "Nolte FZE", value: "Nolte FZE" },
  { label: "FREE LANCE", value: "FREE LANCE" },
  { label: "IT CONSULTANT", value: "IT CONSULTANT" },
];
const SalaryRevisionAction = (props) => {
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const navigate = useNavigate();
  const classes = useStyles(props);

  const SelectCriteria = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refLocation = useRef();
    const [selectedCountry, setSelectedCountry] = useState(null);
    const handleCountryChange = async (value) => {
      if (!value) return;
      props.node.setData(data);
      if (selectedCountry !== value) {
        data.revisionValue = null;
        data.revisedSalary = null;
      }
      setSelectedCountry(value);
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedCountry?.label;
        },
      };
    });

    return (
      <div className="w-full">
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refLocation}
          value={selectedCountry}
          onChange={handleCountryChange}
          options={[
            { label: "Value", value: "value" },
            { label: "Percentage", value: "percentage" },
          ]}
          styles={customStyles()}
        />
      </div>
    );
  });

  const [rowData, setRowData] = useState([
    {
      description: "Basic",
      currentSalary: "25500.00",
      lastRevision: "01.01.2022",
      revisionCriteria: "Value",
      revisionValue: "500.00",
      revisionPercentage: "10%",
      revisionDate: "01-01-2023",
      revisedSalary: "26,000",
      remark: "Testing",
    },
    {
      description: "Housing",
      currentSalary: "5500.00",
      lastRevision: "01.01.2022",
      revisionCriteria: "Percentage",
      revisionValue: "500.00",
      revisionPercentage: "10%",
      revisionDate: "01-01-2023",
      revisedSalary: "6050",
      remark: "Testing",
    },
    {
      description: "Transport / others",
      currentSalary: "5500.00",
      lastRevision: "01.01.2022",
      revisionCriteria: "Percentage",
      revisionValue: "500.00",
      revisionPercentage: "10%",

      revisionDate: "01-01-2023",
      revisedSalary: "6050",
      remark: "Testing",
    },
    {
      description: "Car",
      currentSalary: "5500.00",
      lastRevision: "01.01.2022",
      revisionCriteria: "Percentage",
      revisionValue: "500.00",
      revisionPercentage: "10%",

      revisionDate: "01-01-2023",
      revisedSalary: "6050",
      remark: "Testing",
    },
    {
      description: "Flight Allowance",
      currentSalary: "5500.00",
      lastRevision: "01.01.2022",
      revisionCriteria: "Percentage",
      revisionValue: "500.00",
      revisionPercentage: "10%",

      revisionDate: "01-01-2023",
      revisedSalary: "6050",
      remark: "Testing",
    },
  ]);

  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format("DD-MM-YYYY");
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "description",
      headerName: "Description",
      editable: false,
      filter: "agNumberColumnFilter",
    },
    {
      field: "currentSalary",
      headerName: "Current Salary",
      maxWidth: 100,
      // cellRenderer: PostingCheckboxRenderer,
    },
    // {
    //   field: "lastRevision",
    //   headerName: "Last Revision",
    //   // cellRenderer: InventoryCheckboxRenderer,
    // },
    // -------------------- CRITERIA REMOVED FROM NEW UX by KIM-------------------------
    {
      field: "revisionCriteria",
      headerName: "Revision Criteria",
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectCriteria,
    },
    // -------------------- CRITERIA REMOVED FROM NEW UX by KIM-------------------------

    {
      field: "revisionValue",
      headerName: "Revision Value",
      maxWidth: 100,
    },
    {
      field: "revisionPercentage",
      headerName: "Revision Percentage",
      maxWidth: 140,
    },
    // {
    //   field: "revisionDate",
    //   type: "editableColumn",
    //   headerName: "Revision Date",
    //   cellEditor: DateFromEditorComponent,
    //   cellRenderer: handleDateFormat,
    //   minWidth: 150,
    // },
    {
      field: "revisedSalary",
      headerName: "Revised Salary",
      maxWidth: 100,
    },
    {
      field: "remark",
      headerName: "Remarks",
    },
  ]);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(expenseListURL);
      // let expenseClaimList = list.data._embedded.expenses;
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  const onRowDoubleClicked = (params) => {
    navigate("/payroll/employee/profile");
  };

  // const onSelectionChanged = (params) => {
  //   setSelectedRows(params.api.getSelectedRows());
  // };

  const onCellValueChanged = (params) => {
    // if (params.column.colId === "revisionValue") {
    //   const rowIndex = params.node.rowIndex;
    //   const updatedData = { ...params.data, revisedSalary: 100 };
    //   await params.api.applyTransaction({
    //     update: [{ data: updatedData }],
    //   });
    // }
    params.api.refreshCells({ force: true });
  };

  const onRowValueChanged = useCallback((event) => {
    var data = event.data;
    data.revisedSalary = 100;
  }, []);

  // const getContextMenuItems = (event) => {
  //   var result = [
  //     {
  //       name: "View",
  //       icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
  //       action: (props) => {
  //         navigate(`/payroll/salary/revision/view?id=${event.node.data.id}`);
  //       },
  //     },
  //     {
  //       name: "Edit",
  //       icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
  //       action: (props) => {
  //         navigate(`/payroll/salary/revision/edit?id=${event.node.data.id}`);
  //       },
  //     },
  //     {
  //       name: "Print",
  //       icon: '<span><i class="material-icons" style="font-size: 18px">print</i></span>',
  //       action: (props) => {
  //         // navigate(`/expense-claim/add?id=${event.node.data.id}`);
  //       },
  //     },

  //     // {
  //     //   name: "Delete",
  //     //   icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
  //     //   action: () => {
  //     //     onDelete(event);
  //     //   },
  //     // },
  //   ];
  //   return result;
  // };

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const handleTabChange = (event, value) => setTabValue(value);

  const revisionArr = [
    { lastRevision: "Dec 2023", currentRevision: "01/01/2024" },
    { lastRevision: "Jan 2022", currentRevision: "01/02/2022" },
    { lastRevision: "May 2021", currentRevision: "01/06/2021" },
  ];
  console.log(tabValue);

  return (
    <React.Fragment>
      <FormPageHeader
        componentName="List"
        pageName="Salary Revision"
        currentPage="Salary Revision"
      />

      <Stack direction={"row"} className={"items-end"} sx={{ padding: 2 }}>
        <Stack className="mr-16">
          Emp Code
          <StyledTextField
            type="text"
            className="w-[80px]"
            variant="outlined"
            name="year"
          />
        </Stack>
        <Stack className="mr-16">
          Department
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Sub Department
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Designation
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Emp Name
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          Pay Group
          <Select
            className="w-[150px]"
            name="approval_status"
            placeholder="Status"
            defaultValue={payGroupOptions[0]}
            options={payGroupOptions}
            styles={customStyles()}
          />
        </Stack>
        <Stack className="mr-16">
          <label>Processed Date</label>

          <CustomDatePicker
            className="w-[150px] p-0"
            format={"dd-MM-yyyy"}
            name={"fromDate"}
            value={fromDate}
            handleChange={(e) => {
              setFromDate(e);
            }}
          />
        </Stack>
        <Stack className="mr-16">
          <label>Effective Date</label>
          <CustomDatePicker
            className="w-[150px]"
            format={"dd-MM-yyyy"}
            name={"toDate"}
            value={toDate}
            minDate={fromDate}
            handleChange={(e) => {
              setToDate(e);
            }}
          />
        </Stack>
      </Stack>
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          display: "flex",
          padding: 2,
        }}
      >
       <Tabs
          orientation="vertical"
          variant="scrollable"
          value={tabValue}
          onChange={handleTabChange}
          textColor="inherit"
          aria-label="Vertical tabs example"
          sx={{ borderRight: 1, borderColor: "divider" }}
        >
          {revisionArr.map((item, index) => {
            return (
              <Tab
                key={index}
                label={
                  <div>
                    {item.lastRevision}
                    <h6>Effective on: {item.currentRevision}</h6>
                  </div>
                }
                {...a11yProps(index)}
                sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
              />
            );
          })}
        </Tabs>
        {revisionArr.map((item, index) => {
          return (
            <TabPanel value={tabValue} index={index}>
              <AgGridTable
                hideCheckbox={true}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                gridRef={gridRef}
                rowData={rowData}
                rowGroupPanelShow="never"
                editable={urlParams.val === "view" ? false : true}
                pagination={false}
                onRowValueChanged={onRowValueChanged}
                onCellValueChanged={onCellValueChanged}
              />
            </TabPanel>
          );
        })}
      </Box>

      {/* <Grid container spacing={1}>
        <Grid item xs={6} className="flex">
          <div
            style={{
              border: "1px whitesmoke solid",
              margin: "15px 0px",
              padding: "10px 15px",
            }}
          >
            Current Gross Salary
          </div>
          <div
            style={{
              border: "1px whitesmoke solid",
              borderLeft: "0px",
              margin: "15px 0px",
              padding: "10px 15px",
            }}
          >
            39,500
          </div>
        </Grid>
        <Grid item xs={6} className="flex">
          <div
            style={{
              border: "1px whitesmoke solid",
              margin: "15px 0px",
              padding: "10px 15px",
            }}
          >
            New Gross Salary
          </div>
          <div
            style={{
              border: "1px whitesmoke solid",
              borderLeft: "0px",
              margin: "15px 0px",
              padding: "10px 15px",
            }}
          >
            46,000
          </div>
        </Grid>
      </Grid> */}
    </React.Fragment>
  );
};

export default SalaryRevisionAction;
